import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=07d29f18&scoped=true"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"
import style0 from "./Read.vue?vue&type=style&index=0&id=07d29f18&prod&scoped=true&lang=css"
import style1 from "./Read.vue?vue&type=style&index=1&id=07d29f18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d29f18",
  null
  
)

export default component.exports